import { blob, json, hasErrorCode, hasErrorMessage, } from '@newtontechnologies/beey-api-js-client/receivers';
import { transcodeApi, linkApi, aiToolsApi, refinerApi, } from './endpoints';
const APP_URL_BASE = '/apps';
export const createAppLink = (appPath) => (`${APP_URL_BASE}${appPath}`);
export const fetchJobsOnProject = async (connection, projectId) => connection.fetch()
    .url(transcodeApi.job.id(projectId).groupStatus.url())
    .receive(json())
    .fetch();
export const createBurntCaptionsJob = async (connection, name, begin, end, projectId, workerName) => {
    const body = new FormData();
    body.append('subsFileName', `${name}.vtt`);
    body.append('start', begin);
    body.append('end', end);
    body.append('beeyProjectId', String(projectId));
    body.append('workerName', workerName);
    return connection.fetch()
        .url(transcodeApi.burnSubs.url())
        .post(body)
        .receive(json())
        .fetch();
};
export const createCutMediaJob = async (connection, begin, end, projectId, workerName) => {
    const body = new FormData();
    body.append('beeyProjectId', String(projectId));
    body.append('start', begin);
    body.append('end', end);
    body.append('workerName', workerName);
    return connection.fetch()
        .url(transcodeApi.cut.url())
        .post(body)
        .receive(json())
        .fetch();
};
export const removeJob = async (connection, id) => connection.fetch()
    .url(transcodeApi.job.id(id).remove.url())
    .post()
    .send();
export const startJob = async (connection, id) => connection.fetch()
    .url(transcodeApi.job.id(id).start.url())
    .send();
export const uploadCaptionsForBurn = async (connection, captionsBlob, id, name) => {
    const body = new FormData();
    body.append('jobID', id);
    body.append('file', captionsBlob, `${name}.vtt`);
    return connection.fetch()
        .url(transcodeApi.upload.url())
        .post(body)
        .send();
};
export const downloadModifiedVideo = async (connection, id) => {
    const body = new FormData();
    body.append('jobID', id.toString());
    body.append('-', '-O');
    body.append('-', '-J');
    return connection.fetch()
        .url(transcodeApi.download.url())
        .post(body)
        .receive(blob())
        .fetch();
};
export const transcribeLink = async (connection, url, projectName, projectId, transcribeAttrs) => {
    const body = {
        url,
        name: projectName,
        transcriptionConfig: {
            language: transcribeAttrs.language.code,
            profile: transcribeAttrs.profile,
            withPPC: transcribeAttrs.usePPC,
            withVAD: transcribeAttrs.useVAD,
            withDiarization: transcribeAttrs.useDiarization,
            withSpeakerId: transcribeAttrs.useSpeakerId,
        },
        projectID: projectId,
    };
    return connection.fetch()
        .url(linkApi.ytDl.transcribe.url())
        .postJson(body)
        .send();
};
export const fetchLinkDetail = async (connection, url) => connection.fetch()
    .url(linkApi.ytDl.urlInfo.url())
    .postJson({ url })
    .receive(json()
    .catchHttpError((response, errorPayload) => {
    if (response.status === 422) {
        return { error: 'invalid-format' };
    }
    if (response.status === 415) {
        if (hasErrorMessage(errorPayload, 'Invalid URL.')) {
            return { error: 'invalid-url' };
        }
        return { error: 'third-party-error' };
    }
    if (response.status === 502 || response.status === 503) {
        return { error: 'not-available' };
    }
    return 'unknown';
})
    .finally(() => 'unexpected'))
    .fetchStrict();
export const summarizeProject = async (connection, projectId, targetLanguage, begin, end) => {
    const body = {
        projectId,
        targetLanguage: targetLanguage.code,
        begin,
        end,
    };
    return connection.fetch()
        .url(aiToolsApi.assignments.persistent.summarize.run.url())
        .postJson(body)
        .receive(json()
        .finally(() => 'unexpected'))
        .fetchStrict();
};
export const fetchAiAssignments = async (connection) => connection.fetch()
    .url(aiToolsApi.assignments.url())
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const catchAiError = (_response, errorPayload) => {
    switch (true) {
        case hasErrorCode(errorPayload, 'InputTextIsEmpty'):
            return { error: 'input-text-is-empty' };
        case hasErrorCode(errorPayload, 'ProjectNotFound'):
            return { error: 'project-not-found' };
        case hasErrorCode(errorPayload, 'ProjectHasNoTranscription'):
            return { error: 'project-has-no-transcription' };
        case hasErrorCode(errorPayload, 'MissingProjectId'):
            return { error: 'missing-project-id' };
        case hasErrorCode(errorPayload, 'InvalidFormat'):
            return { error: 'invalid-format' };
        case hasErrorCode(errorPayload, 'InvalidStructure'):
            return { error: 'invalid-structure' };
        case hasErrorCode(errorPayload, 'InvalidValue'):
            return { error: 'invalid-value' };
        case hasErrorCode(errorPayload, 'QuotaExceeded'):
            return { error: 'quota-exceeded' };
        case hasErrorCode(errorPayload, 'RateLimitReached'):
            return { error: 'rate-limit-reached' };
        case hasErrorCode(errorPayload, 'ContentFiltered'):
            return { error: 'content-filtered' };
        case hasErrorCode(errorPayload, 'InvalidRequest'):
            return { error: 'invalid-request' };
        case hasErrorCode(errorPayload, 'Unauthorized'):
            return { error: 'unauthorized' };
        case hasErrorCode(errorPayload, 'Forbidden'):
            return { error: 'forbidden' };
        case hasErrorCode(errorPayload, 'RequestTooLarge'):
            return { error: 'request-too-large' };
        case hasErrorCode(errorPayload, 'ApiOverload'):
            return { error: 'api-overload' };
        case hasErrorCode(errorPayload, 'TokensExceeded'):
            return { error: 'tokens-exceeded' };
        case hasErrorCode(errorPayload, 'UnknownFinishReason'):
            return { error: 'unknown-finish-reason' };
        case hasErrorCode(errorPayload, 'UnknownError'):
            return { error: 'unknown-error' };
        default:
            return 'unknown';
    }
};
export const fetchAiResult = async (connection, projectId, targetLanguage, assignmentName, scopeKind, begin, end, aIProvider, promptLanguage, result, createNewProject, trsxLabel) => {
    const body = {
        targetLanguage,
        scopeKind,
        begin,
        end,
        aIProvider,
        promptLanguage,
        projectId,
        result,
        createNewProject,
        trsxLabel,
    };
    return connection.fetch()
        .url(aiToolsApi.assignments.name(assignmentName).run.url())
        .postJson(body)
        .receive(json()
        .catchHttpError(catchAiError)
        .finally(() => 'unexpected'))
        .fetchStrict();
};
const catchRefinerError = (response) => {
    switch (true) {
        case response.status === 404:
            return { error: 'project-not-found' };
        case response.status === 401:
            return { error: 'unauthorized' };
        case response.status === 403:
            return { error: 'forbidden' };
        case response.status === 422:
            return { error: 'rejected' };
        case response.status === 502 || response.status === 503:
            return { error: 'not-available' };
        default:
            return 'unknown';
    }
};
// The refiner is not a beey-server endpoint: it returns plain snake_case JSON
// with no `Data` envelope, so opt out of the latest-endpoint unwrapping and
// the camelcase conversion.
const refinerJson = () => (json({ endpointType: 'legacy', camelcaseResponse: false }));
export const polishTrsx = async (connection, projectId) => connection.fetch()
    .url(refinerApi.jobs.fromBeey.url())
    .postJson({ project_id: String(projectId), auto_roundtrip: true })
    .receive(refinerJson()
    .catchHttpError(catchRefinerError)
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchRefinerJob = async (connection, jobId) => connection.fetch()
    .url(refinerApi.jobs.id(jobId).url())
    .receive(refinerJson()
    .catchHttpError(catchRefinerError)
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchAiResultCustom = async (connection, prompt, projectId, begin, end, result, trsxLabel) => {
    const body = {
        projectId,
        prompt,
        begin,
        end,
        result,
        trsxLabel,
    };
    return connection.fetch()
        .url(aiToolsApi.assignments.run.url())
        .postJson(body)
        .receive(json()
        .catchHttpError(catchAiError)
        .finally(() => 'unexpected'))
        .fetchStrict();
};
